export default "__VITE_ASSET__640916e2__"